import { data } from "../state/payload";
import { getSizesPerSource } from "./picture-sizes";

// Size factors for the srcset attributes: x1, x2.
const FACTORS = [1, 2];

function buildPictureUrlWithGivenSize(type, filename, size, options = {}) {
	// Force WEBP if not yet forced by backend.
	filename = filename.slice(0, filename.lastIndexOf(".")) + ".webp";

	return `${data.picture_host}/public/cache/${type}/plain-nowater${options.noCrop ? "-nocrop" : ""}/${
		options.stageCropping ? `${options.stageCropping}/` : ""
	}${size}/${filename}`;
}

/**
 * Resizes a image size given a ration. Ex: resize('150x150', 2) => '300x300'.
 */
function resize(size, ratio) {
	return size
		.split("x")
		.map(n => (n === "" ? "" : String(Number.parseInt(n) * ratio)))
		.join("x");
}

/**
 * Formats an IMGSET attribute with the size factors defined above.
 *
 * @param {"hotel"|"article"} type
 * @param {string} filename
 * @param {string} size e.g. 100x100, 200x, x300, or just x
 * @param {Object} [options]
 * @returns {string}
 */
function getSrcSet(type, filename, size, options = {}) {
	return FACTORS.map(
		factor =>
			`${buildPictureUrlWithGivenSize(type, filename, resize(size, factor), options)}  ${factor}x`,
	).join(", ");
}

/**
 * @param {string} filename
 * @param {string} sizeKey e.g. 'picture_gallery' see picture-sizes.js
 * @param {Object} [options]
 * @param {boolean} [options.noCrop] whether to ignore cropping
 * @param {string} [options.stageCropping] cropping data use for stage pictures
 * @returns {string}
 */
export function getPictureUrl(filename, sizeKey, options = {}) {
	const { type, fallBackSize } = getSizesPerSource(sizeKey);
	return buildPictureUrlWithGivenSize(type, filename, fallBackSize, options);
}

/**
 * @param {string} filename
 * @param {string} sizeKey e.g. 'picture_gallery' see picture-sizes.js
 * @param {Object} [filenamePerBreakpoint] screen size specific filenames
 * @param {string} [stageCropping] cropping data use for stage pictures
 * @returns {Object}
 */
export function getPictureSourceSets(
	filename,
	sizeKey,
	filenamePerBreakpoint,
	stageCropping,
) {
	const { fallBackSize, sourcesData, type } = getSizesPerSource(sizeKey);

	const sources = sourcesData.map(({ mediaQuery, size, min }) => ({
		mediaQuery,
		srcset: getSrcSet(type, filenamePerBreakpoint?.[min] || filename, size, {
			stageCropping,
		}),
	}));

	const fallback = buildPictureUrlWithGivenSize(type, filename, fallBackSize, {
		stageCropping,
	});

	return { sources, fallback };
}
